<div id="overlay">
  <div class="flex flex-column positioning">
    <div class="main">
      <div class="main-title">
        {{ "TransferSuccess.Success" | translate }}!
      </div>
      <hr />
      <div class="flex flex-column" style="align-items: center">
        <div *ifPermissions="['Engage Transfer']" class="main-subtitle">
          {{ "TransferSuccess.SuccessTransfer" | translate }}
        </div>
        <div
          *ifPermissions="['Engage Support', 'Internal Admin']"
          class="main-subtitle"
        >
          {{ "TransferSuccess.SuccessGenerate" | translate }}
        </div>
        <app-transfer-success-icon
          [imageWidth]="250"
          [imageHeight]="250"
        ></app-transfer-success-icon>
      </div>
      <div class="flex buttonSection">
        <div class="flex flex-space-between buttonSection-buttons">
          <app-button
            *ifPermissions="['Engage Transfer']"
            buttonColor="accent"
            [buttonText]="'TransferSuccess.History' | translate"
            buttonClass="buttonStyle buttonStyle-outlined"
            (click)="goToHistory()"
          ></app-button>
          <app-button
            *ifPermissions="['Engage Support', 'Internal Admin']"
            buttonColor="accent"
            [buttonText]="'TransferSuccess.History' | translate"
            buttonClass="buttonStyle buttonStyle-outlined"
            (click)="goToHistory()"
          ></app-button>
          <app-button
            *ifPermissions="['Engage Transfer']"
            buttonColor="primary"
            buttonClass="buttonStyle buttonStyle-default"
            [buttonText]="'TransferSuccess.Home' | translate"
            (click)="goToInventory()"
          >
          </app-button>
          <app-button
            *ifPermissions="['Engage Support', 'Internal Admin']"
            buttonColor="primary"
            buttonClass="buttonStyle buttonStyle-default"
            [buttonText]="'TransferSuccess.Home' | translate"
            (click)="goToInventory()"
          >
          </app-button>
        </div>
      </div>
    </div>
  </div>
</div>
